import { GlyphIcon } from './GlyphIcon'

interface ActionGlyphProps {
  className?: string
  direction?: 'back' | 'down' | 'external' | 'forward' | 'up'
}

export function ActionGlyph({ className = '', direction = 'forward' }: ActionGlyphProps) {
  return (
    <GlyphIcon
      className={`action-glyph action-glyph--${direction} ${className}`.trim()}
      name="arrow"
    />
  )
}
